// Dagplan per gebruiker per dag in deze browser: volgorde, tijdblokken en een
// eigen duur voor vandaag. De taken-API heeft (nog) geen veld voor een
// begintijd of volgorde, dus dit blijft bewust lokaal (per kijker, per apparaat).
import { useCallback, useEffect, useState } from 'react';

const LEEG = { volgorde: [], tijden: {}, duur: {} };
const BEWAAR_DAGEN = 14;

function lees(sleutel) {
  try {
    const ruw = window.localStorage.getItem(sleutel);
    if (!ruw) return LEEG;
    const p = JSON.parse(ruw);
    return {
      volgorde: Array.isArray(p.volgorde) ? p.volgorde : [],
      tijden: p.tijden && typeof p.tijden === 'object' ? p.tijden : {},
      duur: p.duur && typeof p.duur === 'object' ? p.duur : {},
    };
  } catch {
    return LEEG;
  }
}

// Oude dagplannen opruimen zodat localStorage niet volloopt.
function ruimOp(prefix, vandaag) {
  try {
    const grens = new Date(`${vandaag}T12:00:00`);
    grens.setDate(grens.getDate() - BEWAAR_DAGEN);
    const grensStr = grens.toISOString().slice(0, 10);
    for (let i = window.localStorage.length - 1; i >= 0; i -= 1) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(prefix)) {
        const datum = k.slice(prefix.length);
        if (datum < grensStr) window.localStorage.removeItem(k);
      }
    }
  } catch { /* opslag niet beschikbaar: niets op te ruimen */ }
}

export function usePlanOpslag(email, datum) {
  const prefix = `vandaag-plan:${(email || 'anoniem').toLowerCase()}:`;
  const sleutel = `${prefix}${datum}`;
  const [plan, setPlan] = useState(() => lees(sleutel));

  useEffect(() => { setPlan(lees(sleutel)); ruimOp(prefix, datum); }, [sleutel, prefix, datum]);

  const bewaar = useCallback((wijzig) => {
    setPlan((vorig) => {
      const volgend = wijzig(vorig);
      try { window.localStorage.setItem(sleutel, JSON.stringify(volgend)); } catch { /* alleen in geheugen */ }
      return volgend;
    });
  }, [sleutel]);

  return [plan, bewaar];
}
